import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const GalleryPage = () => {
  // Galerie-Bilder
  const galleryImages = [
    {
      id: 1,
      url: 'https://customer-assets.emergentagent.com/job_734732b6-8aaf-4bb8-beb8-3e81c5644399/artifacts/3vc0adwt_lackierte%20Eier%20mit%20Unterlegring.JPG',
      title: 'Lackierte Eier mit Unterlegring',
      description: 'Pastellfarbene Styroporeier mit stabilem Standring',
    },
    {
      id: 2,
      url: 'https://customer-assets.emergentagent.com/job_734732b6-8aaf-4bb8-beb8-3e81c5644399/artifacts/racv7e80_Eier%20in%20Natur.JPG',
      title: 'Eier in Natur',
      description: 'Unlackierte Styroporeier in verschiedenen Größen',
    },
    {
      id: 3,
      url: 'https://customer-assets.emergentagent.com/job_734732b6-8aaf-4bb8-beb8-3e81c5644399/artifacts/yfxcrerp_goldenes%20Ei%20mit%20Aufnahme.JPG',
      title: 'Goldenes Ei mit Aufnahme',
      description: 'Luxuriöses goldlackiertes Ei mit Montageaufnahme',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <p className="text-label text-primary mb-4">Einblicke</p>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white leading-tight mb-6">
              Galerie & <span className="text-primary">Produktion</span>
            </h1>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
              Werfen Sie einen Blick hinter die Kulissen unserer Fertigung und sehen Sie 
              unsere Styroporeier in Aktion.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 md:py-16 bg-zinc-900/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className="group relative aspect-square bg-zinc-900 border border-zinc-800 rounded-sm overflow-hidden hover:border-zinc-700 transition-all duration-300"
                data-testid={`gallery-image-${image.id}`}
              >
                {image.url ? (
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-zinc-600">
                    <Camera className="w-16 h-16 mb-4" />
                    <span className="text-sm">Bild folgt</span>
                  </div>
                )}
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-heading text-lg font-bold uppercase tracking-tight text-white mb-1">
                      {image.title}
                    </h3>
                    <p className="text-sm text-zinc-400">
                      {image.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold uppercase tracking-tight text-white mb-6">
            Weitere Bilder auf Anfrage
          </h2>
          <p className="text-zinc-400 mb-8">
            Sie möchten mehr über unsere Produktion erfahren oder benötigen spezifische Referenzbilder? 
            Kontaktieren Sie uns gerne.
          </p>
          <Link to="/configurator">
            <Button 
              className="h-14 px-10 bg-primary text-black font-bold uppercase tracking-wider rounded-sm hover:bg-primary/90 btn-active text-lg"
              data-testid="gallery-cta-button"
            >
              Jetzt konfigurieren
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;
